import { Endpoint } from '@business/api/endpoint';
import { TMEstimatorTemplateFeeId, TMEstimatorTemplateFeeResponse } from '@business/entities/tm/TMEstimatorTemplateFeeResponse';
import { TMEstimatorTemplateFeeFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/AddEditEstimatorTemplateFeeModal/AddEditEstimatorTemplateFeeModal';

export function fetchTMEstimatorTemplateFees() {
  return Endpoint.get<TMEstimatorTemplateFeeResponse[]>(`@gc/estimator-template-fees`);
}

export function createTMEstimatorTemplateFee(data: TMEstimatorTemplateFeeFormData) {
  return Endpoint.post<TMEstimatorTemplateFeeResponse>(`@gc/estimator-template-fees`, { data });
}

// changeNote: the reason for the change (required, kept in the Activity Log)
export function updateTMEstimatorTemplateFee(
  estimatorTemplateFeeId: TMEstimatorTemplateFeeId,
  data: TMEstimatorTemplateFeeFormData,
  changeNote: string,
) {
  return Endpoint.patch<TMEstimatorTemplateFeeResponse>(`@gc/estimator-template-fees/${estimatorTemplateFeeId}`, { data: { ...data, changeNote } });
}

export function deleteTMEstimatorTemplateFee(estimatorTemplateFeeId: TMEstimatorTemplateFeeId, changeNote: string) {
  return Endpoint.delete<void>(`@gc/estimator-template-fees/${estimatorTemplateFeeId}`, { data: { changeNote } });
}

export function fetchTMEstimatorTemplateFee(estimatorTemplateFeeId: TMEstimatorTemplateFeeId) {
  return Endpoint.get<TMEstimatorTemplateFeeResponse>(`@gc/estimator-template-fees/${estimatorTemplateFeeId}`);
}

export function getFeeVariables() {
  return Endpoint.get<string[]>(`@gc/estimator-template-fees/variables`);
}
